import React from "react"

import { selectEffectiveUserType } from "../../../../modules/context/contextSelectors"
import { UserType } from "../../../../modules/login/loginTypes"
import { useAppSelector } from "../../../../modules/store/storeHooks"

import { BillReceiversType, BillTypeMap } from "../billReceiverTypes"

import { PrivateCompanyForm } from "./PrivateCompanyForm"
import { PrivatePersonForm } from "./PrivatePersonForm"
import { PublicInstitutionForm } from "./PublicInstitutionForm"

const componentsMap: BillTypeMap<React.ComponentType<any>> = {
    [BillReceiversType.PRIVATE_PERSON]: PrivatePersonForm,
    [BillReceiversType.PUBLIC_INSTITUTION]: PublicInstitutionForm,
    [BillReceiversType.PRIVATE_COMPANY]: PrivateCompanyForm,
}

export const DynamicForm = ({ componentType }: { componentType: BillReceiversType }) => {
    const userType = useAppSelector(selectEffectiveUserType)
    const Component = componentsMap[componentType]
    return Component ? <Component isMerchantAdmin={userType === UserType.MERCHANT} /> : null
}
